module.exports = "/_next/static/images/f3ccf8fdfe497abf54daaf6822f2c85c-cucuta-perks-xs-2x.jpg.webp";